import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { getApi } from '../api';
import getAccountShipmentRoutesBatch from '../getAccountShipmentRoutesBatch';
import getAccountShipmentV2 from '../getAccountShipmentV2';

export type PostAccountShipmentStopsVariables = {
  accountId: number;
  shipmentId: number;
  payload: { stops: Record<string, unknown>[] };
};

/** Stop row returned after bulk create (id + sequence for route legs). */
export type PostedShipmentStopRow = {
  id: number;
  sequence: number;
};

/**
 * POST `/api/v2/accounts/{account}/shipments/{shipment}/stops` — initial stops (draft wizard).
 */
export default function usePostAccountShipmentStops() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      accountId,
      shipmentId,
      payload,
    }: PostAccountShipmentStopsVariables) => {
      const { api, baseURL } = getApi();
      const res = await api.post(
        `/api/v2/accounts/${accountId}/shipments/${shipmentId}/stops`,
        payload,
        { baseURL },
      );
      return (res.data?.data ?? res.data) as PostedShipmentStopRow[];
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['account-shipments'] });
      queryClient.invalidateQueries({
        queryKey: getAccountShipmentV2.queryKey(
          variables.accountId,
          variables.shipmentId,
        ),
      });
      queryClient.invalidateQueries({
        queryKey: getAccountShipmentRoutesBatch.queryKey(
          variables.accountId,
          [variables.shipmentId],
        ),
      });
    },
  });
}
